/* VEIRA — tm-nuancier
   Pilote le nuancier photo de la fiche produit :
   - survol d'une pastille  -> la galerie saute sur la photo du coloris + bulle du nom
   - clic sur une pastille   -> coloris choisi : on pousse la valeur dans le(s) menu(s)
                                « Couleur » de tm-pack (le thème recalcule prix + panier)
   Aucun fichier d'origine touché. Tout est défensif : si la galerie ou tm-pack
   n'est pas là, le nuancier reste utilisable (au pire il ne bouge pas la photo). */
(function () {
  'use strict';

  function initOne(root) {
    if (root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    var handle = root.getAttribute('data-product-handle') || '';
    var optName = (root.getAttribute('data-option-name') || 'Couleur').toLowerCase();
    var customSel = root.getAttribute('data-gallery-selector') || '';
    var valueOut = root.querySelector('[data-tm-nuancier-value]');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('.tm-nuancier__sw'));
    if (!swatches.length) return;

    var selectedValue = null;

    // --- Galerie native Horizon -------------------------------------------
    function gallery() {
      try {
        if (customSel) {
          var c = document.querySelector(customSel);
          if (c) return c;
        }
        return (
          document.querySelector('.product-details media-gallery') ||
          document.querySelector('media-gallery')
        );
      } catch (e) {
        return null;
      }
    }

    // Fait défiler la galerie jusqu'à la Nᵉ image. idx < 0 -> 1re image.
    function galleryGo(idx, animate) {
      var target = idx;
      if (target === null || target === undefined || isNaN(target) || target < 0) target = 0;
      var g = gallery();
      if (!g) return;
      try {
        var ss = g.slideshow || (g.refs && g.refs.slideshow);
        if (ss && typeof ss.select === 'function') {
          ss.select(target, undefined, { animate: animate !== false });
          return;
        }
      } catch (e) {
        /* on tente le repli ci-dessous */
      }
      try {
        var slides = g.querySelectorAll('slideshow-slide, .product-media-container');
        if (slides && slides[target] && slides[target].scrollIntoView) {
          slides[target].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      } catch (e) {
        /* tant pis */
      }
    }

    // --- Menus « Couleur » de tm-pack pour CE produit --------------------
    function colourSelects() {
      var out = [];
      try {
        var mine = swatches.map(function (b) { return b.getAttribute('data-value'); });

        // 1) chemin propre : les emplacements tm-pack marqués pour ce produit
        var slots = document.querySelectorAll('[data-tm-pack-slot][data-product="' + handle + '"]');
        if (slots.length) {
          slots.forEach(function (slot) {
            slot.querySelectorAll('select.tm-pack__select').forEach(function (sel) {
              var byName = (sel.getAttribute('data-opt-name') || sel.getAttribute('aria-label') || '').toLowerCase();
              if (byName === optName) out.push(sel);
            });
          });
        }
        // 1 bis) produit principal des autres offres (ex. pack fournisseur AutoDS) :
        //    menu dont le libellé affiché est « Couleur » (ex. « Color » traduit)
        document.querySelectorAll('[data-tm-pack-slot][data-main="1"]').forEach(function (slot) {
          if (slot.getAttribute('data-product') === handle) return;
          slot.querySelectorAll('select.tm-pack__select').forEach(function (sel) {
            var byLabel = (sel.getAttribute('data-opt-label') || '').toLowerCase();
            if (byLabel === optName && out.indexOf(sel) === -1) out.push(sel);
          });
        });
        if (out.length) return out;

        // 2) repli : n'importe quel menu tm-pack dont la liste de valeurs
        //    correspond EXACTEMENT à nos pastilles (évite de toucher au
        //    menu couleur d'un autre produit du pack, ex. la laisse).
        document.querySelectorAll('select.tm-pack__select').forEach(function (sel) {
          var vals = Array.prototype.slice.call(sel.options).map(function (o) { return o.value; });
          if (vals.length !== mine.length) return;
          var allIn = mine.every(function (v) { return vals.indexOf(v) !== -1; });
          if (allIn) out.push(sel);
        });
      } catch (e) {
        /* pas de tm-pack : on renvoie une liste vide */
      }
      return out;
    }

    function mediaIndexFor(value) {
      for (var i = 0; i < swatches.length; i++) {
        if (swatches[i].getAttribute('data-value') === value) {
          return parseInt(swatches[i].getAttribute('data-media-index'), 10);
        }
      }
      return -1;
    }

    function setName(txt) {
      if (valueOut) valueOut.textContent = txt ? '— ' + txt : '';
    }

    function applySelection(value) {
      selectedValue = value;
      swatches.forEach(function (b) {
        var on = b.getAttribute('data-value') === value;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      setName(value);
      colourSelects().forEach(function (sel) {
        // On accepte la valeur exacte OU son libellé traduit (ex. pastille « Noir » = option « Black »)
        var match = Array.prototype.slice.call(sel.options).filter(function (o) {
          return o.value === value || o.textContent.trim() === value;
        })[0];
        if (match && sel.value !== match.value) {
          sel.value = match.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    // --- Événements sur chaque pastille ---------------------------------
    swatches.forEach(function (b) {
      var val = b.getAttribute('data-value');
      var nm = b.getAttribute('data-name') || val;
      var idx = parseInt(b.getAttribute('data-media-index'), 10);

      b.addEventListener('mouseenter', function () {
        setName(nm);
        galleryGo(idx, true);
      });
      b.addEventListener('focus', function () {
        setName(nm);
        galleryGo(idx, true);
      });
      b.addEventListener('click', function () {
        applySelection(val);
        galleryGo(idx, true);
      });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          applySelection(val);
          galleryGo(idx, true);
        }
      });
    });

    // Quitter la rangée -> on revient au coloris sélectionné.
    root.addEventListener('mouseleave', function () {
      setName(selectedValue);
      if (selectedValue) galleryGo(mediaIndexFor(selectedValue), true);
    });

    // --- État initial : on lit le menu tm-pack s'il existe, sinon la
    //     pastille marquée is-selected par le Liquid, sinon la première.
    var init = null;
    var sels = colourSelects();
    if (sels.length && sels[0].value) init = sels[0].value;
    if (!init) {
      var pre = swatches.filter(function (b) { return b.classList.contains('is-selected'); })[0];
      if (pre) init = pre.getAttribute('data-value');
    }
    if (!init) init = swatches[0].getAttribute('data-value');
    if (init) applySelection(init);
  }

  function boot() {
    document.querySelectorAll('tm-nuancier').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Rechargement d'une section dans l'éditeur Shopify : on rebinde.
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('tm-nuancier').forEach(function (n) { n.dataset.bound = ''; });
    boot();
  });
})();
